export const FETCH_STORE_SETTINGS_REQUEST = 'storeSettings/FETCH_STORE_SETTINGS_REQUEST';
export const FETCH_STORE_SETTINGS_SUCCESS = 'storeSettings/FETCH_STORE_SETTINGS_SUCCESS';
export const FETCH_STORE_SETTINGS_FAILURE = 'storeSettings/FETCH_STORE_SETTINGS_FAILURE';
